export const labels = 
  { titulo: ["Calidad educativa", "Educational quality"], 
subtitulo: ["El mejor antídoto contra las tiranías", "The best antidote againts tyrannies"],
boton1: ["Conoce el libro", "Know the book"],
boton2: ["Comprar libro", "Buy book"], }